/** Espelha ATS.Hub.API.Vendas.Enums.TipoDestinatarioAutomacaoVendaEnum. */
export enum TipoDestinatarioAutomacaoVendaEnum {
  ResponsavelPeloCard = 1,
  Perfil = 2,
  Usuario = 3,
}
